/* eslint-disable @typescript-eslint/no-unused-vars */
import { Config, LaunchBetbyResponse } from "../../http/protocol";
import { Device } from "../../utils/Device";


export default class BetbyClientService {
  client: BTRenderer | undefined;
  onTokenExpiredCallback: (() => Promise<any>) | undefined;
  onLoginCallback: (() => void) | undefined
  pushSearchParamCallback: ((path: string)=> void) | undefined
  onRegisterCallback: (()=> void) | undefined
  onRechargeCallback: (() => void) | undefined


  constructor(config: BetbyParamters, onTokenExpiredCallback?: () => Promise<any>, onLoginCallback?: () => void, pushSearchParamCallback?: (path: string) => void, onRegisterCallback?: () => void, onRechargeCallback?: () => void) {
    this.onTokenExpiredCallback = onTokenExpiredCallback;
    this.initializeClient(config);
    this.onLoginCallback = onLoginCallback;
    this.pushSearchParamCallback = pushSearchParamCallback;
    this.onRegisterCallback = onRegisterCallback;
    this.onRechargeCallback = onRechargeCallback;
  }

  private initializeClient(config: BetbyParamters) {
    try {
      this.client = new BTRenderer().initialize(this.setConfig(config));
    } catch (error) {
      console.error("Error initializing BTRenderer:", error);
      throw error;
    }
  }

  private setConfig(config: BetbyParamters): any {
    let betbyConfig: Partial<BetbyConfig> | undefined = undefined;

    if(config){
      betbyConfig = this.handleConfig(config);
    }
    return {
      ...betbyConfig,
      target: document.getElementById("betby"),
      onTokenExpired: () => {
        return this.onTokenExpired();
      },
      onRouteChange: (path: string) => {
        this.pushSearchParam(path)
      },
      onLogin: () =>  {
        this.onLogin();
      },
      onRegister: () => {
        this.onRegister();
      },
      onRecharge: () => {
        this.reCharge();
      },
      onSessionRefresh: function () {},
      onBetSlipStateChange: function () {},
      handlePageChange: function () {},
    };
  }

  private handleConfig(parameters: BetbyParamters): Partial<BetbyConfig>{
    let config: Partial<BetbyConfig> = {};
    if(Device.isMobile()){
      config = Object.assign(config, parameters.config, parameters.mobilOffsetConfig);
    } else {
      config = Object.assign(config, parameters.config, parameters.desktopOffsetConfig);
    }
    return config;
  }

  public unsubscribe() {
    this.client?.kill();
  }

  public updateClient(config: BetbyParamters) {
    this.unsubscribe();
    this.initializeClient(config);

  }

  public updateOptions(path: string){
    this.client?.updateOptions({url: path})
  }

  public async onTokenExpired() {
    if (this.onTokenExpiredCallback) {
      return await this.onTokenExpiredCallback();
    } else {
      return Promise.resolve(null);
    }
  }

  public reCharge(){
    if(this.onRechargeCallback){
      this.onRechargeCallback();
    }
  }

  public pushSearchParam(path: string){
    if(this.pushSearchParamCallback){
      return this.pushSearchParamCallback(path);
    }
  }

  public onRegister(){
    if(this.onRegisterCallback){
      return this.onRegisterCallback();
    }
  }

  public onLogin(){
    if(this.onLoginCallback){
      return this.onLoginCallback();
    }
  }

}

export interface BetbyConfig {
  brand_id: string;
  token: string | null;
  onTokenExpired: () => any;
  themeName: string;
  lang: string;
  target: HTMLElement | null;
  betSlipOffsetTop: number;
  betslipZIndex: number;
  onRouteChange: () => unknown;
  onLogin: () => unknown;
  onRegister: () => unknown;
  onSessionRefresh: () => unknown;
  onBetSlipStateChange: () => unknown;
}


/* ------------------------------------------------------------------------ */
/* ------------------------------------------------------------------------ */

export interface InitializeBetbyConfig {
  lang?: string;
  brand_id?: string;
  currency?: string;
  themeName?: string;
  token?: string | null;
  apiUrl?: string;
}

type OffsetConfig = Pick<Config, "betSlipOffsetBottom" | "betSlipOffsetTop" | "betSlipOffsetRight" | "betslipZIndex" | "stickyTop">

export interface BetbyParamters {
  mobilOffsetConfig: OffsetConfig,
  desktopOffsetConfig: OffsetConfig,
  config: InitializeBetbyConfig;
}

export function handleConfig(fetchedConfig: LaunchBetbyResponse, lang: string): BetbyParamters{
  let mobilOffsetConfig: OffsetConfig = {};
  let desktopOffsetConfig: OffsetConfig = {};
  let config: InitializeBetbyConfig= {};

  try {
    if (fetchedConfig.config) {
      const { stickyTop, betSlipOffsetTop, betSlipOffsetBottom, betSlipOffsetRight, betslipZIndex } = fetchedConfig.config;
      const { stickyTopMobile, betSlipOffsetTopMobile, betSlipOffsetBottomMobile, betSlipOffsetRightMobile, betslipZIndexMobile } = fetchedConfig.config;

      desktopOffsetConfig.stickyTop = stickyTop;
      desktopOffsetConfig.betSlipOffsetTop = betSlipOffsetTop;
      desktopOffsetConfig.betSlipOffsetBottom = betSlipOffsetBottom;
      desktopOffsetConfig.betSlipOffsetRight = betSlipOffsetRight;
      desktopOffsetConfig.betslipZIndex = betslipZIndex;

      mobilOffsetConfig.stickyTop = stickyTopMobile;
      mobilOffsetConfig.betSlipOffsetTop = betSlipOffsetTopMobile;
      mobilOffsetConfig.betSlipOffsetBottom = betSlipOffsetBottomMobile;
      mobilOffsetConfig.betSlipOffsetRight = betSlipOffsetRightMobile;
      mobilOffsetConfig.betslipZIndex = betslipZIndexMobile;

      config.lang = lang;
      config.brand_id = fetchedConfig.config.brand_id;
      config.currency = fetchedConfig.config.currency;
      config.themeName = fetchedConfig.config.themeName;
      config.token = fetchedConfig.token ? fetchedConfig.token : null;

      if (fetchedConfig.proxyUrl) {
        config.apiUrl = fetchedConfig.proxyUrl
      }


    }
  } catch (error) {
      throw new Error("Invalid Config")
  }

  return {config: config, mobilOffsetConfig: mobilOffsetConfig, desktopOffsetConfig: desktopOffsetConfig}

}
